import React, { Component } from 'react';

import './App.css';
import CrashMapContainer from './components/crashMapContainer/crashMapContainer.js'

class App extends Component {
  render() {
    return (
      <CrashMapContainer />
    );
  }
}

export default App;